package one.healthium.onboarding.di

import one.healthium.onboarding.data.AppOnboardingRepository
import one.healthium.onboarding.domain.OnboardingInteractor
import one.healthium.onboarding.domain.OnboardingRepository
import org.koin.core.module.dsl.factoryOf
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.bind
import org.koin.dsl.module

val onboardingDataModule = module {
    includes(onboardingPlatformModule())
    singleOf(::AppOnboardingRepository) bind OnboardingRepository::class

    factoryOf(::OnboardingInteractor)
}